<template>
  <div class="mobile-index-box margin-top">
    <div class="total-bg">
      <div class="total-item">
        <p>服务总数</p>
        <p><b>{{ totle_num }}</b> 次</p>
      </div>
      <div class="total-item2">
        <p><img src="../../../assets/img/mobile/mobile-ban.png" alt="">搬</p>
        <p><b>{{ ban_num }}</b> 次</p>
      </div>
      <div class="total-item2">
        <p><img src="../../../assets/img/mobile/mobile-sao.png" alt="">扫</p>
        <p><b>{{ sao_num }}</b> 次</p>
      </div>
      <div class="total-item2">
        <p><img src="../../../assets/img/mobile/mobile-huan.png" alt="">换</p>
        <p><b>{{ huan_num }}</b> 次</p>
      </div>
      <div class="total-item3">
        <p>居民满意度</p>
        <p><b>{{ manyi_lv }} %</b></p>
      </div>
    </div>
  </div>
</template>

<script>
import {phoneDateTwo} from "@/api/weilao";

export default {
  name: "totalPage",
  data() {
    return {
      totle_num: 0,
      ban_num: 0,
      sao_num: 0,
      huan_num: 0,
      manyi_lv: 0,
    }
  },
  created() {
    this.init()
  },
  components: {},
  methods: {
    async init() {
      const res = await phoneDateTwo()
      console.log(res)
      this.totle_num = res.data.totle_num
      this.ban_num = res.data.ban_num
      this.sao_num = res.data.sao_num
      this.huan_num = res.data.huan_num
      // this.manyi_lv = res.data.manyi_lv
      // this.totle_num = 258
      // this.ban_num = 87
      // this.sao_num = 95
      // this.huan_num = 76
      this.manyi_lv = 100

    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.mobile-index-box {
  min-height: calc(100vh - 150px);

  .total-bg {
    background: url(../../../assets/img/mobile/mobile-db.png) no-repeat top center;
    background-size: 100% 100%;
    padding: 30px 20px;

    .total-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      background: url(../../../assets/img/mobile/mobile-info-bg.png) no-repeat top center;
      background-size: 100% 100%;
      padding: 40px 30px 30px;

      &:last-child {
        margin-bottom: 0;
      }

      p {
        font-size: 20px;
        line-height: 150%;

        b {
          font-size: 26px;
          color: #fc3333;
          font-weight: 500;
          font-style: italic;
        }
      }
    }

    .total-item2 {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      background: url(../../../assets/img/mobile/mobile-info-small.png) no-repeat top center;
      background-size: 100% 100%;
      padding: 25px 30px;

      &:last-child {
        margin-bottom: 0;
      }

      p {
        font-size: 20px;
        line-height: 150%;

        img {
          width: 22px;
          margin-right: 5px;
        }

        b {
          font-size: 26px;
          color: #fc3333;
          font-weight: 500;
          font-style: italic;
        }
      }
    }

    .total-item3 {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      background: url(../../../assets/img/mobile/mobile-info-red.png) no-repeat top center;
      background-size: 100% 100%;
      padding: 30px;

      &:last-child {
        margin-bottom: 0;
      }

      p {
        font-size: 20px;
        line-height: 150%;
        color: #fff;

        b {
          font-size: 26px;
          color: #ffe64a;
          font-weight: 500;
          font-style: italic;
        }
      }
    }
  }

  .next-btn {
    width: 50%;
    height: 40px;
    background: #fff;
    border-radius: 20px;
    text-align: center;
    line-height: 40px;
    margin: 30px auto 0;
    font-size: 16px;
    color: #f84e4e;
  }
}
</style>
